import { render, staticRenderFns } from "./ItemAdd.vue?vue&type=template&id=69d1e90e&"
import script from "./ItemAdd.vue?vue&type=script&lang=ts&"
export * from "./ItemAdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports